import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { IGroup } from '../types/group'
import { IGroups } from '../types/groups'

export const selectGroups = createSelector(
  [(state: AppStateType) => state.groups],
  (groups: IGroups) => groups
)

export const selectGroupsList = createSelector(
  selectGroups,
  ({ list }) => list.filter(({ hidden }) => !hidden)
)

export const selectGroupById = (groupId: string) =>
  createSelector(
    selectGroups,
    ({ list }): IGroup | undefined => list.find(({ name }) => name === groupId)
  )
